import { Subject } from 'rxjs';
import { DeferredData, Rpc } from '../rpc';
import { RpcSubjectServer } from '../rpc-subject-server';
import { RpcUpdateDataHandler } from './rpc-update-data-handler';
import { RpcUpdateData, RpcUpdateDataKey } from './rpc-update-data-model';

/**
 * Update data subject interface.
 */
export interface RpcUpdateDataSubject extends Subject<DeferredData<RpcUpdateData, void>> {}

/**
 * The class to implement update data with Subject server.
 */
export class RpcUpdateDataSubjectServer extends RpcSubjectServer<RpcUpdateData, void> implements RpcUpdateDataHandler {
    /**
     * Initializes a new instance of the RpcUpdateDataSubjectServer class.
     */
    constructor(rpc: Rpc) {
        super(rpc, RpcUpdateDataKey.command);
    }

    /**
     * The handler to respond a request for update data call.
     *
     * @param data The update data object.
     * @returns Promise<void> the promise object.
     */
    public handler(data: RpcUpdateData): Promise<void> {
        return this.processNextForSubject(RpcUpdateDataKey.command, data);
    }
}
